import React from 'react'
import SbEditable from 'storyblok-react'
import Heading from 'src/components/Heading';
import RichText from 'src/utils/RichText'
import Button from 'src/components/Button'
import Logo from 'src/images/logo_swirl.svg'
import { BackgroundColour, LabelColourLighten } from 'src/utils/ColourUtilities';
import { ScrollPercentage } from 'react-scroll-percentage'

const SimpleCenterBranded = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <ScrollPercentage>
                {({ percentage, ref, entry }) => (
                    <div class={`relative overflow-hidden ${BackgroundColour(blok.background_colour)}`} ref={ref}>
                        <div className="absolute top-0 bottom-0 w-full h-full z-0 m-auto">
                            <Logo 
                                className={`absolute w-full h-[185%] -top-0 md:-top-1/2 bottom-0 m-auto ${LabelColourLighten(blok.background_colour)}`} 
                                style={{ 'transform': `scale(${1 + (percentage.toPrecision(4) / 3)})` }}
                            />
                        </div>
                        <div className="relative max-w-2xl mx-auto text-center py-16 px-8 sm:py-40 sm:px-6 lg:px-8 z-10">
                            <Heading size="h3" className="text-white max-w-2xl my-6 mt-0 sm:mt-2">{blok.title}</Heading>
                            <div className="mt-4 text-base text-white max-w-lg m-auto">
                                <RichText>{blok.content}</RichText>
                            </div>
                            <Button to={blok.button_link.cached_url} anchor={blok.button_link.anchor} className="bg-blue hover:bg-darkblue mt-6">{blok.button_label}</Button>
                        </div>
                    </div>
                )}
            </ScrollPercentage>
        </SbEditable>
    )
}

export default SimpleCenterBranded